<div class="home-main-container">
  <div *ngIf="!logoUrl || logoUrl.length === 0">
    <app-shimmer-ui></app-shimmer-ui>
  </div>
  <!-- <div *ngIf="logoUrl && logoUrl.length != 0">
    <div class="demo-div rect-view" *ngIf="!isMobile()">
      <div class="column">
        <div>
          <img src="../../assets/images/Star 1.png" class="star1" alt="star1" />
          <div>
            <h1 class="title-text">Simplifying School Performance</h1>
          </div>
          <img src="../../assets/images/Star 2.png" class="star2" alt="star2" />
        </div>

        <div class="sub-text">
          All you Need for Hassle-Free Streamlined Operations and Better
          Productivity!
        </div>

        <div>
          <button mat-raised-button class="btn-demo" (click)="goToPage()">
            Book a demo &nbsp;&nbsp;
            <mat-icon>arrow_right_alt</mat-icon>
          </button>
        </div>
      </div>
      <div class="column lottie-div" style="width: 35%">
        <div style="margin-top: 100px; margin-left: 110px">
          <ng-lottie
            [options]="lottieOptions"
            [height]="'180px'"
            [width]="'180px'"
            (animationCreated)="animationCreated($event)"
          ></ng-lottie>
        </div>
        <img
          src="../../../assets/images/logo_small.png"
          alt="Inforida"
          style="position: relative; top: -122px; left: 170px; height: 60px"
        />
      </div>
    </div>
  </div>

  <div class="demo-div rect-view" *ngIf="isMobile()">
    <div class="lottie-div" style="width: 80vw; height: 280px"></div>
    <div class="lottie">
      <ng-lottie
        [options]="lottieOptions"
        [height]="'160px'"
        [width]="'160px'"
      ></ng-lottie>
    </div>
    <div class="logo">
      <img
        src="../../../assets/images/logo_small.png"
        alt="Inforida"
        style="width: 15%"
      />
    </div>

    <div>
      <div class="title-text">Simplifying School Performance</div>
      <div class="sub-text">
        All you Need for Hassle-Free Streamlined Operations and Better
        Productivity!
      </div>

      <div>
        <button mat-raised-button class="btn-demo" (click)="goToPage()">
          Book a demo &nbsp;&nbsp;
          <mat-icon>arrow_right_alt</mat-icon>
        </button>
      </div>
    </div>
  </div> -->

  <!-- <div class="heading-container">
    <div class="measure-div-title">Join our growing list of Schools</div>
    <div class="measure-div-subtitle">
      Inforida is trusted by the schools for managing their day-to-day
      administrations
    </div>
    <div class="heading">
      <h1>
        Saving
        <om-gradient-text
          [text]="'Precious hours'"
          [gradientStart]="'rgba(0, 102, 253, 1)'"
          [gradientEnd]="'rgba(239, 72, 253, 1)'"
          styleClass="custom-gradient-text"
        ></om-gradient-text>
        of your day In School Management
      </h1>
    </div>
    <p>
      Simplify operations, reduce admin tasks, and focus on what truly matters -
      Educating Students.
    </p>
    <button (click)="goToPage()">Book Free Demo Now</button>
    <div *ngIf="logoUrl?.length">
      <div class="carousel-container">
        <div class="carousel-images" *ngIf="isImageLoaded">
          <ng-image-slider
            [imageSize]="getImgSize()"
            [autoSlide]="autoSlide"
            [infinite]="infiniteSlide"
            [showArrow]="false"
            [animationSpeed]="1"
            [images]="logoUrl"
            #gallery
          ></ng-image-slider>
          <div class="marquee-wrapper">
            <om-marquee [animationDuration]="'40s'">
              <div
                class="marquee-card"
                *ngFor="let logo of logoUrl"
                #OmMarqueeContent
              >
                <img [src]="logo.url" class="school-logos" />
              </div>
            </om-marquee>
            <div class="marquee-gradient left"></div>
            <div class="marquee-gradient right"></div>
          </div>
        </div>
      </div>
    </div>
  </div> -->
  <div class="omfade-container">
    <om-fade
      [direction]="'up'"
      [transitionDuration]="'0.5s'"
      [transitionFunction]="'linear'"
      [animateOnlyOnce]="true"
    >
      <div class="new-home-container">
        <div class="input-wrapper">
          <div class="left-section">
            <h1>
              The
              <!-- <om-gradient-text
                [text]="'Smarter Way'"
                [gradientStart]="'rgba(0, 102, 253, 1)'"
                [gradientEnd]="'rgba(239, 72, 253, 1)'"
                styleClass="custom-gradient-text"
              ></om-gradient-text> -->
              <om-shiny-text
                [text]="'Smarter Way'"
                [textColor]="'rgba(0, 102, 253, 0.9)'"
                [shimmerColor]="'rgba(0, 0, 0, 1)'"
              ></om-shiny-text>
              to Manage Your Education Institutes<span class="dot"></span>
              <!-- <img src="../../../assets/images/mall-star2.png" class="image1" />
              <img
                src="../../../assets/images/small-star1.png"
                class="image2"
              /> -->
            </h1>

            <p>
              Simplify operations, reduce admin tasks, and focus on what truly
              matters - Educating Students.
            </p>

            <div class="buttons">
              <button class="button blue" (click)="goToPage()">
                Book Free Demo →
              </button>
              <!-- <button class="button green" (click)="goToWhatsApp()">
                <p>Join Our community</p>
                <p style="display: flex">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 39 39"
                  >
                    <path
                      fill="#00E676"
                      d="M10.7 32.8l.6.3c2.5 1.5 5.3 2.2 8.1 2.2 8.8 0 16-7.2 16-16 0-4.2-1.7-8.3-4.7-11.3s-7-4.7-11.3-4.7c-8.8 0-16 7.2-15.9 16.1 0 3 .9 5.9 2.4 8.4l.4.6-1.6 5.9 6-1.5z"
                    ></path>
                    <path
                      fill="#FFF"
                      d="M32.4 6.4C29 2.9 24.3 1 19.5 1 9.3 1 1.1 9.3 1.2 19.4c0 3.2.9 6.3 2.4 9.1L1 38l9.7-2.5c2.7 1.5 5.7 2.2 8.7 2.2 10.1 0 18.3-8.3 18.3-18.4 0-4.9-1.9-9.5-5.3-12.9zM19.5 34.6c-2.7 0-5.4-.7-7.7-2.1l-.6-.3-5.8 1.5L6.9 28l-.4-.6c-4.4-7.1-2.3-16.5 4.9-20.9s16.5-2.3 20.9 4.9 2.3 16.5-4.9 20.9c-2.3 1.5-5.1 2.3-7.9 2.3zm8.8-11.1l-1.1-.5s-1.6-.7-2.6-1.2c-.1 0-.2-.1-.3-.1-.3 0-.5.1-.7.2 0 0-.1.1-1.5 1.7-.1.2-.3.3-.5.3h-.1c-.1 0-.3-.1-.4-.2l-.5-.2c-1.1-.5-2.1-1.1-2.9-1.9-.2-.2-.5-.4-.7-.6-.7-.7-1.4-1.5-1.9-2.4l-.1-.2c-.1-.1-.1-.2-.2-.4 0-.2 0-.4.1-.5 0 0 .4-.5.7-.8.2-.2.3-.5.5-.7.2-.3.3-.7.2-1-.1-.5-1.3-3.2-1.6-3.8-.2-.3-.4-.4-.7-.5h-1.1c-.2 0-.4.1-.6.1l-.1.1c-.2.1-.4.3-.6.4-.2.2-.3.4-.5.6-.7.9-1.1 2-1.1 3.1 0 .8.2 1.6.5 2.3l.1.3c.9 1.9 2.1 3.6 3.7 5.1l.4.4c.3.3.6.5.8.8 2.1 1.8 4.5 3.1 7.2 3.8.3.1.7.1 1 .2h1c.5 0 1.1-.2 1.5-.4.3-.2.5-.2.7-.4l.2-.2c.2-.2.4-.3.6-.5s.4-.4.5-.6c.2-.4.3-.9.4-1.4v-.7s-.1-.1-.3-.2z"
                    ></path>
                  </svg>
                </p>
              </button> -->
            </div>
            <!-- <div *ngIf="logoUrl?.length">
            <div class="carousel-container">
              <div class="carousel-images">
                <div class="marquee-wrapper">
                  <om-marquee [animationDuration]="'40s'">
                    <div
                      class="marquee-card"
                      *ngFor="let logo of logoUrl"
                      #OmMarqueeContent
                    >
                      <img [src]="logo.url" class="school-logos" />
                    </div>
                  </om-marquee>
                  <div class="marquee-gradient left"></div>
                  <div class="marquee-gradient right"></div>
                </div>
              </div>
            </div>
          </div> -->
          </div>
          <div class="right-section">
            <!-- <img
              src="https://inforida.ams3.cdn.digitaloceanspaces.com/assets/header-lottie.gif"
              alt="image"
            /> -->
            <lottie-player
              src="../../../assets/lottie/HeroDashboardLottie.json"
              background="transparent"
              speed="1"
              class="main-lottie"
              loop
              autoplay
            >
            </lottie-player>
          </div>
        </div>
        <div *ngIf="logoUrl?.length">
          <div class="carousel-container">
            <div class="carousel-images">
              <div class="marquee-wrapper">
                <om-marquee [animationDuration]="'60s'" [marqueeGap]="'0rem'">
                  <div
                    class="marquee-card"
                    *ngFor="let logo of logoUrl"
                    #OmMarqueeContent
                  >
                    <img [src]="logo.url" class="school-logos" />
                  </div>
                </om-marquee>
                <div class="marquee-gradient left"></div>
                <div class="marquee-gradient right"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </om-fade>
  </div>

  <!-- <div class="left-circle left-pos blue-circle"></div> -->

  <app-features-card class="features-card"></app-features-card>

  <!-- <div class="display align-centr" style="flex-direction: column; width: 100%">
    <div class="measure-div-title mb-mr">
      Built for everyone in your ecosystem
    </div>

    <div class="people-box people-grid eco-card" style="height: 265px">
      <div class="people-card people-main-div">
        <img src="../../assets/images/Frame 7657.svg" alt="info" style="width: 25%; margin-top: 20px"/>
        <div class="card-text" style="margin-top: 0px; font-size: 20px">
          Admin staff
        </div>
        <div class="line"></div>
        <div class="card-text people-card-text" style="margin-top: 10px">
          Student Admission, Fee collection, Real time Insights & Reports, Staff
          Attendance, Manage Roles & Permissions
        </div>
      </div>
      <div class="people-card people-main-div">
        <img
          src="../../assets/images/Frame 7658.svg"
          style="width: 25%; margin-top: 20px"
        />
        <div class="card-text" style="margin-top: 0px; font-size: 18px">
          Academic staff
        </div>
        <div class="line"></div>
        <div class="card-text people-card-text" style="margin-top: 10px">
          Class Attendance, Homework & Assignment, Student Performance, Send
          Reminders & Alerts
        </div>
      </div>
      <div class="people-card people-main-div">
        <img
          src="../../assets/images/Frame 7659.svg"
          style="width: 25%; margin-top: 20px"
        />
        <div class="card-text" style="margin-top: 0px; font-size: 18px">
          Parents
        </div>
        <div class="line"></div>

        <div class="card-text people-card-text" style="margin-top: 10px">
          NoticeBoard, Student Attendance & Homework, Fees Summary and History,
          Events Calender & TimeTable, Student Performance Reports
        </div>
      </div>
    </div>
  </div> -->

  <app-cards-wrap
    heading1="The"
    heading2="Four Pillars of"
    heading3="Inforida"
    heading4="Ecosystem"
    subheading="See how you can benefit →"
    [array]="fourPillars"
  ></app-cards-wrap>

  <app-how-we-do style="width: 100%"></app-how-we-do>

  <!-- <div class="digital-presence-container">
    <h2>
      Improve Your <br />
      <span>Digital Presence</span>
    </h2>
    <div class="digital-presence-wrapper">
      <div class="digital-presence-right-section">
        <h2>
          Improve Your <br />
          <span>Digital Presence</span>
        </h2>
        <p>
          Create A Government-Compliant Public Page To Showcase Your School's
          Facilities, Infracture, Achievements.
        </p>
        <p>With Real-Time Editing, Customisable Banners, And Vibrant Themes</p>
        <a>Learn how we can do it for you →</a>
      </div>
      <div class="digital-presence-left-section">
        <div class="digital-background"></div>
      </div>
    </div>
  </div> -->

  <app-we-do
    logo="https://inforida.ams3.cdn.digitaloceanspaces.com/assets/quick-enroll-ai.png"
    heading="Improve Your"
    highlight="Digital Presence"
    [points]="description"
    [data]="quickEnrollPoints"
    imageLink="https://inforida.ams3.cdn.digitaloceanspaces.com/assets/quickenroll%20image.png"
    linkText="Learn how we can do it for you →"
    link="/products/QuickEnroll-AI"
    [isMorning]="false"
  ></app-we-do>

  <app-we-do
    logo="https://inforida.ams3.cdn.digitaloceanspaces.com/assets/goood-morning-logo.png"
    heading="Fast Secure"
    highlight="Paperless Attendance"
    [points]="goodmorningDescription"
    [data]="attendancePoints"
    imageLink="https://inforida.ams3.cdn.digitaloceanspaces.com/assets/attendance.png"
    linkText="Get Goood Morning for Your School →"
    link="/products/goood-morning"
    [isMorning]="true"
  ></app-we-do>

  <div class="work-container">
    <div class="work-background"></div>
    <img
      src="https://inforida.ams3.cdn.digitaloceanspaces.com/assets/inforida-round-logo.png"
      class="info-logo"
    />
    <div class="benifits-container">
      <!-- <h1>
        Why you will
        <span
          >love <br />
          using</span
        >
        Inforida<span>.</span>
      </h1> -->
      <h1>Why you will love using Inforida.</h1>
      <div class="benifits-wrapper">
        <div class="benifits-card" *ngFor="let card of benifits">
          <div class="benifits-icon">
            <mat-icon>{{ card.icon }}</mat-icon>
          </div>
          <div class="benifits-text">
            <h3>{{ card.title }}</h3>
            <p>{{ card.description }}</p>
          </div>
        </div>
      </div>
      <!-- <a><span>Sounds good?</span> Get to know more benifits →</a> -->
      <div class="benifits-foooter" routerLink="/contact-us">
        <mat-icon>call</mat-icon>
        <p>Talk to an Expert</p>
      </div>
    </div>
  </div>

  <!-- <div>
    <div class="measure-div-title">How We do it with Inforida Ecosystem</div>
    <div class="measure-div-subtitle">
      Bridging the Gap: Helping Schools Achieve its Vision
    </div>
    <div class="display vision">
      <div class="info-card rect-view num-1">
        <div class="number">1</div>
        <img
          src="../../assets/images/Group 7506.svg"
          alt="info"
          style="margin-left: 34px; margin-top: 21px"
        />
        <div class="card-text card-text-info">Activate your school</div>
        <div class="card-text card-sub-text">
          Hassle-Free Onboarding with your Existing data in 10 Mins
        </div>
      </div>
      <div class="info-card rect-view num-2">
        <div class="number">2</div>
        <img
          src="../../assets/images/Group 7517.svg"
          alt="info"
          style="margin-left: 34px; margin-top: 21px"
        />
        <div class="card-text card-text-info">Start tracking KPIs</div>

        <div class="card-text card-sub-text">
          View charts and reports that you need. All with a single click.
        </div>
      </div>
      <div class="info-card rect-view num-3">
        <div class="number">3</div>
        <img
          src="../../assets/images/Group 7509.svg"
          alt="info"
          style="margin-left: 34px; margin-top: 21px"
        />
        <div class="card-text card-text-info">Measure</div>
        <div class="card-text card-sub-text">
          Analyze Day to Day complex Operations
        </div>
      </div>
      <div class="info-card rect-view num-4">
        <div class="number">4</div>
        <img
          src="../../assets/images/Group 7510.svg"
          alt="info"
          style="margin-left: 34px; margin-top: 21px"
        />
        <div class="card-text card-text-info">Improve</div>
        <div class="card-text card-sub-text">
          Increase Operational efficiency across Departments.
        </div>
      </div>
    </div>
  </div> -->

  <!-- <div *ngIf="!isMobile()">
    <div class="measure-div-title">The Four Pillars of Inforida Ecosystem</div>
    <div class="measure-div-subtitle" style="line-height: 29px">
      Inforida’s 4 Pillar helps you Bring Productivity and Performance in your
      School
    </div>
  </div>
  <div class="display" *ngIf="!isMobile()">
    <div class="pillar-box rect-view">
      <div class="pillar-card display">
        <div class="product-card">
          <div class="piller-name rect-view">
            <img
              src="../../assets/images/Group 7540.svg"
              class="piller-image"
              alt="info"
            /><span class="piller-subtext">Finance</span>
          </div>
          <div class="piller-card-view" style="background-color: #def5e6">
            <div style="margin: 50px 0px 0px 25px">
              <div>
                <img src="../../assets/images/96 - [DESIGN.png" alt="info" />
                <span class="piller-image-text">Fee Collection Efficency</span>
              </div>
              <div style="margin-top: 10px">
                <img
                  src="../../assets/images/44 - [DESIGN.png"
                  alt="info"
                /><span class="piller-image-text">Income/Expense Tracking</span>
              </div>
              <div style="margin-top: 10px">
                <img
                  src="../../assets/images/28 - [DESIGN.png"
                  alt="info"
                /><span class="piller-image-text"
                  >Insights to Payment Channels</span
                >
              </div>
            </div>
          </div>
        </div>

        <div class="product-card">
          <div class="piller-name rect-view">
            <img
              src="../../assets/images/Group 7130.svg"
              class="piller-image"
            /><span class="piller-subtext">People</span>
          </div>
          <div class="piller-card-view" style="background-color: #fbf3d9">
            <div style="margin: 50px 0px 0px 25px">
              <div>
                <img src="../../assets/images/96 - [DESIGN.png" alt="info" />
                <span class="piller-image-text">People performance</span>
              </div>
              <div style="margin-top: 10px">
                <img
                  src="../../assets/images/44 - [DESIGN.png"
                  alt="info"
                /><span class="piller-image-text">Smart Payroll</span>
              </div>
              <div style="margin-top: 10px">
                <img
                  src="../../assets/images/28 - [DESIGN.png"
                  alt="info"
                /><span class="piller-image-text">Role management</span>
              </div>
            </div>
          </div>
        </div>

        <div class="product-card">
          <div class="piller-name rect-view">
            <img
              src="../../assets/images/Group 7160.svg"
              class="piller-image"
            /><span class="piller-subtext">Classroom</span>
          </div>
          <div class="piller-card-view" style="background-color: #fcebe7">
            <div style="margin: 50px 0px 0px 25px">
              <div>
                <img src="../../assets/images/96 - [DESIGN.png" alt="info" />
                <span class="piller-image-text"
                  >Class Atttendance & Discipline</span
                >
              </div>
              <div style="margin-top: 10px">
                <img
                  src="../../assets/images/44 - [DESIGN.png"
                  alt="info"
                /><span class="piller-image-text">Resource</span>
              </div>
              <div style="margin-top: 10px">
                <img
                  src="../../assets/images/28 - [DESIGN.png"
                  alt="info"
                /><span class="piller-image-text">Parent Feedback </span>
              </div>
            </div>
          </div>
        </div>

        <div class="product-card">
          <div class="piller-name communication rect-view">
            <img
              src="../../assets/images/Group 7131.svg"
              alt="info"
              class="piller-image"
            /><span class="piller-subtext">Communication</span>
          </div>
          <div class="piller-card-view" style="background-color: #e0ebfd">
            <div style="margin: 50px 0px 0px 25px">
              <div>
                <img src="../../assets/images/96 - [DESIGN.png" />
                <span class="piller-image-text">Engagement Rate</span>
              </div>
              <div style="margin-top: 10px">
                <img src="../../assets/images/44 - [DESIGN.png" /><span
                  class="piller-image-text"
                  >Income/Expense Tracking</span
                >
              </div>
              <div style="margin-top: 10px">
                <img src="../../assets/images/28 - [DESIGN.png" /><span
                  class="piller-image-text"
                  >Insights to Payment Channels</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="measure-div-title piller-txt">
        The Power of visibility & simplicity
      </div>
      <div class="display btn-mr">
        <button
          mat-raised-button
          class="btn-get product-btn"
          style="margin: 10px !important"
          routerLink="/products"
        >
          Explore our products &nbsp;&nbsp;
          <mat-icon>arrow_right_alt</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="isMobile()" style="width: 106%">
    <div>
      <div class="measure-div-title">
        The Four Pillars of Inforida Ecosystem
      </div>
      <div class="measure-div-subtitle" style="line-height: 29px">
        Inforida’s 4 Pillar helps you Bring Productivity and Performance in your
        School
      </div>
    </div>
    <div class="display">
      <div class="pillar-box rect-view">
        <div class="pillar-card display">
          <div class="product-card">
            <div class="piller-name rect-view">
              <img
                src="../../assets/images/Group 7540.svg"
                class="piller-image"
                alt="info"
              /><span class="piller-subtext">Finance</span>
            </div>
            <div class="piller-card-views" style="background-color: #def5e6">
              <div style="margin: 50px 0px 0px 25px">
                <div>
                  <img src="../../assets/images/96 - [DESIGN.png" alt="info" />
                  <span class="piller-image-text"
                    >Fee Collection Efficency</span
                  >
                </div>
                <div style="margin-top: 10px">
                  <img
                    src="../../assets/images/44 - [DESIGN.png"
                    alt="info"
                  /><span class="piller-image-text"
                    >Income/Expense Tracking</span
                  >
                </div>
                <div style="margin-top: 10px; margin-bottom: 15px">
                  <img
                    src="../../assets/images/28 - [DESIGN.png"
                    alt="info"
                  /><span class="piller-image-text"
                    >Insights to Payment Channels</span
                  >
                </div>
              </div>
            </div>
          </div>

          <div class="product-card">
            <div class="piller-name rect-view">
              <img
                src="../../assets/images/Group 7130.svg"
                class="piller-image"
              /><span class="piller-subtext">People</span>
            </div>
            <div class="piller-card-views" style="background-color: #fbf3d9">
              <div style="margin: 50px 0px 0px 25px">
                <div>
                  <img src="../../assets/images/96 - [DESIGN.png" alt="info" />
                  <span class="piller-image-text">People performance</span>
                </div>
                <div style="margin-top: 10px">
                  <img
                    src="../../assets/images/44 - [DESIGN.png"
                    alt="info"
                  /><span class="piller-image-text">Smart Payroll</span>
                </div>
                <div style="margin-top: 10px; margin-bottom: 15px">
                  <img
                    src="../../assets/images/28 - [DESIGN.png"
                    alt="info"
                  /><span class="piller-image-text">Role management</span>
                </div>
              </div>
            </div>
          </div>

          <div class="product-card">
            <div class="piller-name rect-view">
              <img
                src="../../assets/images/Group 7160.svg"
                class="piller-image"
              /><span class="piller-subtext">Classroom</span>
            </div>
            <div class="piller-card-views" style="background-color: #fcebe7">
              <div style="margin: 50px 0px 0px 25px">
                <div>
                  <img src="../../assets/images/96 - [DESIGN.png" alt="info" />
                  <span class="piller-image-text"
                    >Class Atttendance & Discipline</span
                  >
                </div>
                <div style="margin-top: 10px">
                  <img
                    src="../../assets/images/44 - [DESIGN.png"
                    alt="info"
                  /><span class="piller-image-text">Resource</span>
                </div>
                <div style="margin-top: 10px; margin-bottom: 15px">
                  <img
                    src="../../assets/images/28 - [DESIGN.png"
                    alt="info"
                  /><span class="piller-image-text">Parent Feedback </span>
                </div>
              </div>
            </div>
          </div>

          <div class="product-card">
            <div class="piller-name communication rect-view">
              <img
                src="../../assets/images/Group 7131.svg"
                alt="info"
                class="piller-image"
              /><span class="piller-subtext">Communication</span>
            </div>
            <div class="piller-card-views" style="background-color: #e0ebfd">
              <div style="margin: 50px 0px 0px 25px">
                <div>
                  <img src="../../assets/images/96 - [DESIGN.png" />
                  <span class="piller-image-text">Engagement Rate</span>
                </div>
                <div style="margin-top: 10px">
                  <img src="../../assets/images/44 - [DESIGN.png" /><span
                    class="piller-image-text"
                    >Income/Expense Tracking</span
                  >
                </div>
                <div style="margin-top: 10px; margin-bottom: 15px">
                  <img src="../../assets/images/28 - [DESIGN.png" /><span
                    class="piller-image-text"
                    >Insights to Payment Channels</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="measure-div-title piller-txt">
          The Power of visibility & simplicity
        </div>
        <div class="display btn-mr">
          <button
            mat-raised-button
            class="btn-get product-btn"
            style="margin: 10px !important"
            routerLink="/products"
          >
            Explore our products &nbsp;&nbsp;
            <mat-icon>arrow_right_alt</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div> -->

  <!-- <div>
    <div class="measure-div-title">Why Measure School Performance</div>
    <div class="measure-div-subtitle">
      The Only Thing That Matters When It Comes To Education
    </div>
    <div class="card-view display">
      <div class="card school_performance">
        <img
          src="../../assets/images/Data Driven Decision Making.svg"
          class="card-img"
          alt="Data Driven Decision Making"
        /><span class="card-text">Data-Driven Policy & Decision Making</span>
      </div>
      <div class="card school_performance">
        <img
          src="../../assets/images/Better Financial Planning.svg"
          class="card-img"
          alt="Better Financial Planning"
        /><span class="card-text">Better Financial Planning</span>
      </div>
      <div class="card school_performance">
        <img
          src="../../assets/images/Academic Growth.svg"
          class="card-img"
          alt="Academic Growth"
        /><span class="card-text">Academic Growth</span>
      </div>
      <div class="card school_performance">
        <img
          src="../../assets/images/Effective People Management.svg"
          class="card-img"
          alt="Effective People Management"
        /><span class="card-text">Effective People Management</span>
      </div>
      <div class="card school_performance">
        <img
          src="../../assets/images/Accelerate Digital Infrastructure.svg"
          alt="Accelerate Digital Infrastructure"
          class="card-img"
        /><span class="card-text">Accelerate Digital Infrastructure</span>
      </div>
      <div class="card school_performance">
        <img
          src="../../assets/images/Design Better Development Programs.svg"
          alt="Design Better Development Programs"
          class="card-img"
        /><span class="card-text">Design Better Development Programs</span>
      </div>
    </div>
  </div> -->

  <!-- 
  <div style="width: 95%">
    <div class="measure-div-title">
      Simple, Secure and Scalable for all Platforms
    </div>
    <div
      class="display device-mr"
      style="margin-top: 20px; align-items: center"
    >
      <div class="platform-card web">
        <span class="card-text card-text-inforida">Web</span
        ><img
          src="../../assets/images/Group 7436.svg"
          alt="info"
          style="width: 200px; margin: 20px"
        />
      </div>
      <div class="platform-card mobile mb-view-device">
        <span class="card-text card-text-inforida" style="font-size: 30px"
          >Mobile</span
        ><img
          src="../../assets/images/image 17.svg"
          alt="info"
          style="width: 190px; margin: 20px 50px 0px 50px"
        />
      </div>

      <div class="platform-card tab">
        <span class="card-text card-text-inforida">Tablet</span
        ><img
          src="../../assets/images/image 20.svg"
          alt="info"
          style="width: 200px; margin: 20px"
        />
      </div>
    </div>
  </div> -->

  <div class="banner-wrapper">
    <!-- <om-dotpattern [patternColor]="'rgba(7, 183, 82, 1)'"> -->
    <om-shine-border
      [borderRadius]="'50px'"
      [borderColor]="'#ffffff'"
      [gradientColorStart]="'#ade6c6'"
      [gradientColorMiddle]="'#0fe86d'"
      [gradientColorEnd]="'rgb(3, 96, 0)'"
      [animationDuration]="'7s'"
    >
      <div class="banner-container">
        <h2>
          Go
          <!-- <om-gradient-text
            [text]="'Greener'"
            [gradientStart]="'rgb(133, 184, 131)'"
            [gradientEnd]="'rgba(43, 184, 38, 1)'"
            styleClass="custom-gradient-text"
          ></om-gradient-text> -->
          <om-shiny-text
            [text]="'Greener'"
            [textColor]="'#07b752'"
          ></om-shiny-text>
          With Inforida.
        </h2>
        <div class="banner-innerwrap">
          <div class="banner-text">
            <h1>
              <om-shiny-text
                [text]="'6,307+'"
                [textColor]="'#07b752'"
              ></om-shiny-text>
              trees saved
              <!-- <span class="trees-saved">+</span> -->
            </h1>
            <p>
              Streamline your school operations, eliminate paper clutter, and
              contribute to a sustainable future. With schools across India
              going paperless through Infotida, we’ve saved over 1 lakh trees so
              far—driving meaningful change for the environment.
            </p>
            <button class="banner-button" routerLink="/products/inforida-orbit">
              Go Green with Infotida →
            </button>
          </div>
          <div class="image-section">
            <!-- <ng-lottie
                  [options]="lottieTree"
                  [height]="'300px'"
                  [width]="'300px'"
                  (animationCreated)="animationCreated($event)"
                ></ng-lottie> -->
            <lottie-player
              src="../../../assets/lottie/treeLottie.json"
              background="transparent"
              speed="0.3"
              style="width: 300px; height: 300px"
              loop
              autoplay
            >
            </lottie-player>
            <!-- <img src="../assets/images/tree.svg" alt="Tree Design" /> -->
          </div>
        </div>
      </div>
    </om-shine-border>
    <!-- </om-dotpattern> -->
  </div>

  <!--  <div class="whatsapp-section">
    <div class="whatsapp-card">
      <div class="whatsapp-icon">
        <img src="../../assets/images/whatsappicon.svg" alt="WhatsApp Icon" />
      </div>
      <div class="whatsapp-text">
        <h3>Stay connected and informed!</h3>
        <p>
          Join our WhatsApp community for exclusive updates, promotions, and
          more
        </p>
      </div>
      <a
        href="https://chat.whatsapp.com/EDdRZIoKcBZ3MGMCe9mCid"
        target="_blank"
        mat-raised-button
        color="primary"
        class="join-now-button"
        >Join Now</a
      >
    </div>
  </div>

  <div class="display flex-d device-mr" style="width: 95%">
    <div class="measure-div-title">Why you should choose Inforida?</div>
    <div class="display why-card" style="margin-top: 20px">
      <div class="display design-card">
        <img
          src="../../assets/images/activate.svg"
          alt="info"
          style="width: 35%"
          class="why-img"
        /><span class="card-text design-text">Designed & Built for NBU</span>
      </div>
      <div class="display design-card">
        <img
          src="../../assets/images/frame2.svg"
          style="width: 35%"
          class="why-img"
        /><span class="card-text design-text">Multilanguage support</span>
      </div>
      <div class="display design-card">
        <img
          src="../../assets/images/pricing.svg"
          alt="info"
          style="width: 35%"
          class="why-img"
        /><span class="card-text design-text"
          >Flexible Pricing (Pay as you go)</span
        >
      </div>
      <div class="display design-card">
        <img
          src="../../assets/images/nbu.svg"
          alt="info"
          style="width: 35%"
          class="why-img"
        /><span class="card-text design-text">Activate in Just 10 min</span>
      </div>
      <div class="display design-card">
        <img
          src="../../assets/images/multilanguage.svg"
          alt="info"
          style="width: 35%"
          class="why-img"
        /><span class="card-text design-text"
          >Smart support for Your ecosystem</span
        >
      </div>
    </div>
  </div>

  <div class="graph-div rect-view grid-col" *ngIf="!isMobile()">
    <div>
      <div class="graph-text">
        Digitising and Simplifying all complex operations for your school
        ecosystem.
      </div>
    </div>
    <div style="margin-top: 20px">
      <div style="margin-top: 25px">
        <img src="../../assets/images/Group 7420.svg" alt="info" />
      </div>
    </div>
  </div> -->
</div>
<!-- <div class="key-features-container">
          <div class="feature-card">
            <div class="content-container">
              <div class="card-image">
                <img src="../../../assets/images/for-teachers.png" alt="Illustration for Teachers">
              </div>
              <div class="card-content">
                <h3>For Teachers</h3>
                <p class="feature-title">Job Search Made Simple</p>
                <p class="feature-desc">Filter jobs by location, board, level, subject, position <br>and experience
                  level.</p>
                <br>
                <p class="feature-title">Seamless Application Process</p>
                <p class="feature-desc">Apply for jobs directly through the platform.</p>
                <br>
                <button mat-raised-button color="primary" class="find-role">Search Job</button>
              </div>
      
            </div>
          </div>
          <div class="feature-card">
            <div class="content-container">
              <div class="card-image">
                <img src="../../../assets/images/for-schools.png" alt="Illustration for Teachers">
              </div>
              <div class="card-content">
                <h3>For Schools</h3>
                <p class="feature-title">Post Jobs in Minutes</p>
                <p class="feature-desc">Easily create job posts and reach a large pool<br> of qualified teachers.</p>
                <br>
                <p class="feature-title">Track Applicants</p>
                <p class="feature-desc">Monitor application statuses and<br> communicate with potential hires directly.
                </p>
                <br>
                <button mat-raised-button color="primary" class="find-role">Post a Job</button>
              </div>
      
            </div>
          </div>
        </div> -->
